import React from 'react';
import images from '../../Asset/Img/img';
import "./FooterLogo.css";

function FooterLogo() {
    return (
        <div className='footer-logo-container'>
            <img src={images.logoWhite} alt="Logo" />
            <p>Telif Hakkı © 2022 OETECH Solutions</p>
        </div>
    )
}

export default FooterLogo